import { createContext } from "react"

export const IconColorContext = createContext<string | undefined>(undefined)
